const o = "_item_1oon0_1", n = "_isLabelIcon_1oon0_8", e = "_disabled_1oon0_28", s = "_iconContainer_1oon0_57", i = {
  item: o,
  isLabelIcon: n,
  disabled: e,
  "size-small": "_size-small_1oon0_49",
  "size-large": "_size-large_1oon0_53",
  iconContainer: s
};
export {
  i as default,
  e as disabled,
  s as iconContainer,
  n as isLabelIcon,
  o as item
};
//# sourceMappingURL=index.es5579.js.map
